import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { post } from 'utils/http'

export const useCustomerDomainCreate = () => {
  const customerId = useCustomerId()
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const createDomain = async (domain: any) => post(`/management/customers/${customerId}/domains`, { domain })

  return useMutation({
    mutationFn: createDomain,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'domains'] })

      addNotification('Domain created successfully', 'success')
    },
  })
}
